import type { PropsWithChildren, RefObject } from 'react'
import { useTheme } from 'styled-components'

import { Typography } from '../../Typography'

import { SegmentWrapper } from './Segment.Styled'

export type SegmentProps = PropsWithChildren<{
  containerRef?: RefObject<HTMLDivElement | null>
  title?: string
}>

export const Segment = ({ children, containerRef, title }: SegmentProps) => {
  const theme = useTheme()

  return (
    <SegmentWrapper ref={containerRef}>
      {title && (
        <Typography
          dangerouslySetInnerHTML={{ __html: title }}
          $color={theme.colors['N Content/Primary']}
          $variant="Poppins/H3 - Medium"
          $textAlign="center"
        />
      )}
      {children}
    </SegmentWrapper>
  )
}
